// extracted by mini-css-extract-plugin
module.exports = {"filters":"_99551c8aa8--filters--LJv0C","filter":"_99551c8aa8--filter--ZfgoJ"};